
import React from 'react';
import MetricCard from '../MetricCard';
import { formatNumberWithCommas } from './metricsUtils';

interface ROICardProps {
  roi: number;
  timeFrame?: string;
  noData?: boolean;
}

const ROICard: React.FC<ROICardProps> = ({ 
  roi, 
  timeFrame = 'Past 30 days',
  noData = false
}) => {
  // If roi is 0 and noData is true, consider it as no data
  // This separates legitimate 0 ROIs from no data situations
  const hasNoData = noData || (roi === 0 && noData);

  return (
    <MetricCard 
      title="ROAS" 
      value={`$${formatNumberWithCommas(roi)}`} 
      tooltip={`Return on ad spend (${timeFrame})`}
      min={0} 
      max={3000} 
      current={roi} 
      hideMinLabel={true}
      noData={hasNoData}
    />
  );
};

export default ROICard;
